import { motion } from "framer-motion";

const CHAPTERS = [
  {
    title: "The Masterpiece of Connection",
    body: "Flooring is the quiet foundation beneath every considered room — the surface that carries light, sound and touch. We treat it as the unifying thread that links one space to the next.",
  },
  {
    title: "The Puzzle Philosophy",
    body: "Timber, Carpet, Tile and Stone. Four distinct elements, each with its own language of texture and tone. Our craft is fitting them together into a single, coherent whole.",
  },
  {
    title: "One Curated Studio",
    body: "For architects, designers, builders and homeowners alike — a single Drummoyne destination where the complex act of selection becomes a calm, guided pleasure.",
  },
];

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.9, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] } }),
};

export default function Manifesto() {
  return (
    <section id="about" className="relative bg-[#121315] pt-12 pb-32 md:pt-20 md:pb-48">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <motion.p
          initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
          className="text-[#C9A876] text-[11px] tracking-[0.4em] uppercase mb-10 md:mb-16"
        >
          Manifesto
        </motion.p>

        <div className="space-y-24 md:space-y-40">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.title}
              custom={i}
              variants={reveal}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-100px" }}
              className={`max-w-2xl ${i % 2 === 1 ? "md:ml-[16%]" : ""}`}
            >
              <h2 className="font-serif-display text-[#F5F4F0] font-light tracking-tight text-3xl sm:text-4xl md:text-5xl leading-[1.05]">
                {c.title}
              </h2>
              <p className="mt-6 text-[#D6D1CA]/80 text-base md:text-lg font-body leading-relaxed">{c.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
